import React from "react";
import styled from "styled-components";
import CustomerReview from "images/homepage/CustomerReview";
import ReviewsCarousel from "./ReviewsCarousel";
import JumpingDucky from "images/homepage/JumpingDucky";
import { IReview } from "data/reviews";

const Container = styled.section.attrs({
    className: "container",
})`
    margin-top: 130px;
`;

interface IProps {
    heading: string;
    reviews: IReview[];
}

export default function CustomerReviews(props: IProps) {
    return (
        <Container>
            <div className="row d-flex align-items-center">
                <div className="col-lg-5 col-md-12 position-relative">
                    <div className="testimonials-title">{props.heading}</div>
                    <CustomerReview width="90%" />
                    <div
                        className="position-absolute"
                        style={{
                            top: "240px",
                            left: "50%",
                            transform: "translateX(-50%)",
                        }}
                    >
                        <JumpingDucky />
                    </div>
                </div>
                <div className="col-lg-7 col-md-12 d-flex flex-column pe-0">
                    <ReviewsCarousel reviews={props.reviews} />
                </div>
            </div>
        </Container>
    );
}
